/**
 * Service Worker Registration Utility
 * Daftarkan SW hanya di production & browser yang mendukung
 */

const SW_URL = `${process.env.PUBLIC_URL}/sw.js`;
const IS_LOCAL = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      if (IS_LOCAL) {
        // Di localhost: tetap register tapi log saja (berguna untuk debug)
        checkValidServiceWorker(SW_URL, config);
      } else {
        registerValidSW(SW_URL, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Update tersedia
              console.log("[SW] Konten baru tersedia. Muat ulang untuk update.");
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              // Instalasi pertama: konten di-cache untuk offline
              console.log("[SW] Konten di-cache untuk offline!");
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("[SW] Gagal mendaftarkan service worker:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // SW tidak ditemukan, reload tanpa SW
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("[SW] Tidak ada koneksi internet — mode offline aktif.");
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
